const Index = () => import('../index.vue');
const FindLocation = () => import('@/modules/Authentication/components/FindLocation.vue');
const EmployeeLogin = () => import('@/modules/Authentication/components/Login.vue');
const Logout = () => import('@/modules/Authentication/components/Logout.vue');

export default [
  {
    path: '/login',
    component: Index,
    title: 'Login',
    children: [
      {
        path: 'location',
        name: 'authentication-find-location',
        component: FindLocation,
        props: true,
      },
      {
        path: '/',
        name: 'authentication-employee-login',
        component: EmployeeLogin,
        props: true,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`) == null) {
            console.log('No location code was found', to); // eslint-disable-line
            let url = '/login/location';
            if (to.query && to.query.code) url = `${url}/?`;
            next({
              path: url,
              params: { nextUrl: to.fullPath },
              query: { ...to.params },
            });
          } else {
            console.log('just next?', to)
            next();
          }
        },
      },
    ],
  },
  {
    path: '/logout',
    name: 'authentication-logout',
    component: Logout,
  },
];
